export default __webpack_public_path__ + "static/purple_spark-10c82b1a4033fab8703f377f74337cb9.png";